import { Link } from 'react-router-dom';
import { hotRankIds } from '@/mocks/guagua';
import { formatViews, getArticleById, getCategoryName } from '@/utils/content';

export default function HotRank() {
  const ranked = hotRankIds
    .map((id) => getArticleById(id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item));

  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading text-xl font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-trophy-line text-accent-500" aria-hidden="true"></i>
          热议榜
        </h3>
        <span className="text-xs text-foreground-400">按阅读量排序</span>
      </div>
      <ol className="space-y-1">
        {ranked.map((item, index) => (
          <li key={item.id}>
            <Link
              to={`/news/${item.id}`}
              className="group flex items-center gap-3 py-3 border-b border-background-100 last:border-0 cursor-pointer"
            >
              <span
                className={`flex items-center justify-center w-8 h-8 rounded-md text-sm font-bold shrink-0 ${
                  index < 3
                    ? 'bg-primary-500 text-background-50'
                    : index < 6
                      ? 'bg-accent-100 text-accent-800'
                      : 'bg-background-100 text-foreground-500'
                }`}
              >
                {index + 1}
              </span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-medium text-foreground-900 leading-snug line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </span>
                <span className="block mt-0.5 text-xs text-foreground-400">
                  {getCategoryName(item.categorySlug)} · {item.comments} 条讨论
                </span>
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-500 shrink-0">
                <i className="ri-fire-line text-primary-400" aria-hidden="true"></i>
                {formatViews(item.views)}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}